import Api from './Api';

export default {
	addToCart(obj) {
		return Api.get('add_to_cart?id=' + obj.id + '&pack=' + obj.pack);
	},
	removeFromCart(obj) {
		return Api.get('remove_from_cart?id=' + obj.id + '&pack=' + obj.pack);
	},
	getAllCart() {
		return Api.get('get_cart');
	},
	getCartById(obj) {
		return Api.post('getCartById', obj);
	},
	addMany(obj) {
		return Api.get('add_many_to_cart?id=' + obj.id + '&value=' + obj.val);
	},
	addManyItems(obj) {
		return Api.get('add_many_items_to_cart?items=' + obj.items);
	}
};
